import {
    GuxFormFieldCheckbox,
    GuxTooltip,
} from "genesys-spark-components-react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
    qualityFormActions,
    selectIsUserDefinedSelectedForQuestionGroup,
    selectQuestionGroupIdContainingQuestion,
} from "features/qualityForm/qualityFormSlice";
import { useStrings } from "features/i18n/useStrings";
import strings from "./Question.strings";
import FeatureToggle from "enums/FeatureToggle";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";

// Styles
import "./DefaultAnswerCheckbox.less";

interface DefaultAnswerCheckboxProps {
    questionId: string;
    optionId: string;
    isMultipleSelect: boolean;
    isDefaultAnswer: boolean;
    isDisabled?: boolean;
    answerIndex?: number;
}

export function DefaultAnswerCheckbox({
    questionId,
    optionId,
    isMultipleSelect,
    isDefaultAnswer,
    isDisabled = false,
    answerIndex,
}: DefaultAnswerCheckboxProps) {
    const dispatch = useAppDispatch();
    const t = useStrings(strings);

    const isEvaluationFormDefaultAnsweringEnabled = useAppSelector((state) =>
        selectFeatureToggle(
            state,
            FeatureToggle.EVALUATION_FORM_DEFAULT_ANSWERING
        )
    );

    const questionGroupId =
        useAppSelector((state) =>
            selectQuestionGroupIdContainingQuestion(questionId)(
                state.qualityForm
            )
        ) ?? "";

    const isUserDefinedSelected = useAppSelector((state) =>
        selectIsUserDefinedSelectedForQuestionGroup(state, questionGroupId)
    );

    const showDefaultAnswerCheckbox =
        isEvaluationFormDefaultAnsweringEnabled && isUserDefinedSelected;

    if (!showDefaultAnswerCheckbox) {
        return null;
    }

    return (
        <div className="DefaultAnswerCheckbox">
            <GuxFormFieldCheckbox>
                <input
                    slot="input"
                    type="checkbox"
                    checked={isDefaultAnswer}
                    disabled={isDisabled}
                    aria-disabled={isDisabled}
                    onChange={() => {
                        dispatch(
                            qualityFormActions.setDefaultAnswer({
                                questionId,
                                optionId,
                                isMultipleSelect,
                            })
                        );
                    }}
                    className="property-section-checkbox"
                />
                <label slot="label">{t.labels.defaultAnswer}</label>
            </GuxFormFieldCheckbox>
            {isDisabled && !isMultipleSelect && (
                <GuxTooltip
                    data-testid={`default-answer-tooltip-${answerIndex}`}
                >
                    {t.labels.tooltip.userDefinedDefaultAnswer}
                </GuxTooltip>
            )}
        </div>
    );
}
